import { useMiniApp } from '@app/providers/miniapp-provider'
import { useChannels } from '@entities/channel'
import image1 from '@shared/assets/main_1.png'
import image2 from '@shared/assets/main_2.png'
import image3 from '@shared/assets/main_3.png'
import image4 from '@shared/assets/main_4.png'
import manWithLaptop from '@shared/assets/man_with_laptop.png'
import imageSlide from '@shared/assets/mobile/main_3_slide.png'
import manWithLaptopIsMobile from '@shared/assets/mobile/man_with_laptop.png'
import rocketIsMobile from '@shared/assets/mobile/rocket.png'
import rocket from '@shared/assets/rocket.png'
import useMobileView from '@shared/hooks/isMobile'
import { BottomNavMobile } from '@widgets/page-template/ui/bottom-nav-mobile'
import { Button, Card, Carousel, Col, Flex, Image, Row, theme, Typography } from 'antd'
import { Link, useNavigate } from 'react-router-dom'
import './style.css'

const { Title, Paragraph, Text } = Typography

export const MainPage = () => {
    const miniappContext = useMiniApp()
    const navigate = useNavigate()

    const {
        token: { colorHighlight, colorBgLayout }
    } = theme.useToken()

    const isMobile = useMobileView()
    const { channels } = useChannels()

    const emptyChannels = channels?.length === 0

    const handleAddToHomeScreen = () => {
        if (miniappContext.canAddAtHomeScreen) {
            miniappContext.telegramWebApp.addToHomeScreen()
        }
    }

    const handleAfterChange = (currentSlide: number) => {
        if (!emptyChannels && currentSlide === 2) {
            navigate('/internet-resources')
        }
    }

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 1,
        afterChange: handleAfterChange // добавляем обработчик
    }

    if (isMobile) {
        return (
            <>
                <div
                    className={'mobile-main-page'}
                    style={{ backgroundColor: '#F0F3F5', paddingTop: 20, paddingBottom: 20, flex: 1, overflow: 'auto' }}
                >
                    <Carousel {...settings} key={location.pathname}>
                        {emptyChannels && (
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'center', height: 620 }}>
                                    <Card style={{ backgroundColor: colorHighlight, width: 358 }}>
                                        <Col>
                                            <Title level={3} style={{ marginTop: 0, textAlign: 'center' }}>
                                                Добро пожаловать в TelegaPlan!
                                            </Title>
                                            <Paragraph style={{ textAlign: 'center', fontSize: 16 }}>
                                                Ваш Telegram-канал — это не просто площадка, а пространство для идей,
                                                контента и роста.
                                            </Paragraph>
                                            <Paragraph style={{ textAlign: 'center', fontSize: 16 }}>
                                                Мы создали TelegaPlan, чтобы управление каналом стало удобным, а ваш
                                                контент работал на вас.
                                            </Paragraph>
                                            <Paragraph style={{ textAlign: 'center', fontSize: 16 }}>
                                                Осталось подключить интернет-ресурс.
                                            </Paragraph>
                                            <Flex justify={'center'} style={{ marginTop: 25 }}>
                                                <Image
                                                    preview={false}
                                                    width={96}
                                                    src={manWithLaptopIsMobile}
                                                    alt="man with laptop"
                                                />
                                                <Image preview={false} width={100} src={rocketIsMobile} alt="rocket" />
                                            </Flex>
                                        </Col>
                                    </Card>
                                </div>
                            </div>
                        )}

                        <div>
                            <div
                                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 620 }}
                            >
                                <div style={{ width: 358 }}>
                                    <Title level={3} style={{ marginBottom: 24, marginTop: 0, textAlign: 'center' }}>
                                        Что вы можете делать с TelegaPlan?
                                    </Title>
                                    <Flex
                                        style={{
                                            padding: '21px 16px 21px 17px',
                                            backgroundColor: colorBgLayout,
                                            borderRadius: 8,
                                            height: '100%',
                                            marginBottom: 10
                                        }}
                                        align="center"
                                        gap={16}
                                    >
                                        <div style={{ textAlign: 'center', width: 150 }}>
                                            <Image src={image1} alt="" preview={false} />
                                        </div>

                                        <Text>
                                            Публиковать контент по расписанию — планируйте посты на недели вперёд без
                                            стресса.
                                        </Text>
                                    </Flex>
                                    <Flex
                                        style={{
                                            padding: '21px 16px 21px 17px',
                                            backgroundColor: colorBgLayout,
                                            borderRadius: 8,
                                            height: '100%',
                                            marginBottom: 10
                                        }}
                                        align="center"
                                    >
                                        <div style={{ width: 216, textAlign: 'center' }}>
                                            <Image src={image2} alt="" preview={false} />
                                        </div>
                                        <Text>
                                            Создавать ЗАКУП рекламы и получать сквозную аналитику с расчетом цены
                                            подписчика и другой статистикой.
                                        </Text>
                                    </Flex>
                                    <Flex
                                        style={{
                                            padding: '21px 16px 21px 17px',
                                            backgroundColor: colorBgLayout,
                                            borderRadius: 8,
                                            height: '100%',
                                            marginBottom: 10
                                        }}
                                        align="center"
                                    >
                                        <div style={{ width: 197 }}>
                                            <Image src={image3} style={{ marginLeft: 7 }} alt="" preview={false} />
                                        </div>
                                        <Text>
                                            Отслеживать аналитику — понимайте, что работает лучше всего и повышайте
                                            вовлечённость.
                                        </Text>
                                    </Flex>
                                    <Flex
                                        style={{
                                            padding: '21px 16px 21px 17px',
                                            backgroundColor: colorBgLayout,
                                            borderRadius: 8,
                                            height: '100%',
                                            marginBottom: 10
                                        }}
                                        align="center"
                                    >
                                        <div style={{ width: 197 }}>
                                            <Image src={image4} style={{ marginLeft: 7 }} alt="" preview={false} />
                                        </div>
                                        <Text>
                                            Маркировать рекламу, генерировать erid, сдать отчетность в ОРД на автомате
                                        </Text>
                                    </Flex>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'center', height: 620 }}>
                                <Link
                                    to={'https://t.me/telegaplanbot/?startapp&addToHomeScreen'}
                                    style={{
                                        width: 358,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <Title level={3} style={{ marginBottom: 24, marginTop: 10, textAlign: 'center' }}>
                                        Что вы можете делать с TelegaPlan?
                                    </Title>
                                    <Flex
                                        style={{
                                            padding: '10px 10p 10px 0',
                                            backgroundColor: colorBgLayout,
                                            borderRadius: 8,
                                            height: '100px',
                                            marginBottom: 10,
                                            position: 'relative'
                                        }}
                                        align="center"
                                    >
                                        <div style={{ width: 147 }}>
                                            <Image src={imageSlide} alt="" preview={false} />
                                        </div>
                                        <div style={{ position: 'absolute', left: 90 }} onClick={handleAddToHomeScreen}>
                                            <Title
                                                style={{ marginTop: 0, marginBottom: 0, fontSize: 14, width: 161 }}
                                                level={5}
                                            >
                                                Нужен быстрый доступ к Telegaplan?
                                            </Title>
                                            <Text style={{ fontSize: 13 }}>Закрепи на главном экране</Text>
                                        </div>
                                    </Flex>
                                </Link>
                            </div>
                        </div>
                        {!emptyChannels && (
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'center', height: 620 }}></div>
                            </div>
                        )}
                    </Carousel>
                    {emptyChannels && (
                        <div
                            style={{
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'center',
                                marginTop: 32
                            }}
                        >
                            <Link to={'/internet-resources?modal=true'}>
                                <Button type="primary" style={{ fontSize: 17, height: 40, borderRadius: 10 }}>
                                    Подключить канал
                                </Button>
                            </Link>
                        </div>
                    )}
                </div>
                <BottomNavMobile />
            </>
        )
    }
    return (
        <Card style={{ height: '90%' }}>
            <Row>
                <Col span={18}>
                    <Card style={{ backgroundColor: colorHighlight }}>
                        <Row gutter={16} align={'middle'}>
                            <Col span={18}>
                                <Title level={3} style={{ marginTop: 0 }}>
                                    Добро пожаловать в TelegaPlan!
                                </Title>
                                <Paragraph strong style={{ marginBottom: 0 }}>
                                    Ваш Telegram-канал — это не просто площадка, а пространство для идей, контента и
                                    роста. Мы создали TelegaPlan, чтобы управление каналом стало удобным, а ваш контент
                                    работал на вас.
                                </Paragraph>
                            </Col>
                            <Col span={3}>
                                <Image src={manWithLaptop} alt="man with laptop" />
                            </Col>
                            <Col span={3}>
                                <Image src={rocket} alt="rocket" />
                            </Col>
                        </Row>
                    </Card>
                    <Title level={4} style={{ marginBottom: 24 }}>
                        Что вы можете делать с TelegaPlan?
                    </Title>
                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Flex
                                style={{
                                    padding: '10px',
                                    backgroundColor: colorBgLayout,
                                    borderRadius: 8,
                                    height: '100%'
                                }}
                                align="center"
                                gap={16}
                            >
                                <div style={{ minWidth: '20%', textAlign: 'center' }}>
                                    <Image src={image1} alt="" preview={false} />
                                </div>

                                <Text>
                                    Публиковать контент по расписанию — планируйте посты на недели вперёд без стресса.
                                </Text>
                            </Flex>
                        </Col>
                        <Col span={12}>
                            <Flex
                                style={{
                                    padding: '10px',
                                    backgroundColor: colorBgLayout,
                                    borderRadius: 8,
                                    height: '100%'
                                }}
                                align="center"
                            >
                                <div style={{ minWidth: '20%', textAlign: 'center' }}>
                                    <Image src={image2} alt="" preview={false} />
                                </div>
                                <Text>
                                    Запускать рекламу — находите лучшие площадки и управляйте размещением без лишних
                                    сложностей.
                                </Text>
                            </Flex>
                        </Col>
                        <Col span={12}>
                            <Flex
                                style={{
                                    padding: '10px',
                                    backgroundColor: colorBgLayout,
                                    borderRadius: 8,
                                    height: '100%'
                                }}
                                align="center"
                            >
                                <div style={{ minWidth: '20%', textAlign: 'center' }}>
                                    <Image src={image3} alt="" preview={false} />
                                </div>
                                <Text>
                                    Отслеживать аналитику — понимайте, что работает лучше всего и повышайте
                                    вовлечённость.
                                </Text>
                            </Flex>
                        </Col>
                        <Col span={12}>
                            <Flex
                                style={{
                                    padding: '10px',
                                    backgroundColor: colorBgLayout,
                                    borderRadius: 8,
                                    height: '100%'
                                }}
                                align="center"
                            >
                                <div style={{ minWidth: '20%', textAlign: 'center' }}>
                                    <Image src={image4} alt="" preview={false} />
                                </div>
                                <Text>Получать уведомления — не пропускайте важные задачи и события.</Text>
                            </Flex>
                        </Col>
                    </Row>
                    <Title level={5}>
                        TelegaPlan — это ваш надежный помощник в развитии канала. Давайте создадим что-то великое!
                    </Title>
                </Col>
            </Row>
        </Card>
    )
}
